import { useEffect } from 'react'
import MainLayout from '../../../layouts/MainLayout'
import { useNavigate, useParams } from 'react-router-dom'
import '../../../assets/styles/custom-styles.css'
import useNotification from '../../../hooks/useNotification'
import useLoader from '../../../hooks/useLoader'
import useForm from '../../../hooks/useForm'
import { setDefaultFieldValues } from '../../../utils/objectUtils'
import { detailsProductFields } from '../../../constants/forms/almoxarifado/productFields'
import DetailsSectionRenderer from '../../../components/DetailsSectionRenderer'
import useBaseService from '../../../hooks/services/useBaseService'
import { entities } from '../../../constants/entities'
import PageHeader from '../../../components/PageHeader'
import TableDetails from '../../../components/table/TableDetails'
import useQueryWithLoader from '../../../hooks/useQueryWithLoader'

const DetailsProductPage = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const { showNotification } = useNotification()
  const { showLoader, hideLoader } = useLoader()
  const { formData, setFormData } = useForm(
    setDefaultFieldValues(detailsProductFields)
  )
  const { getByColumn: baseServiceGetByColumn } = useBaseService(navigate)

  const {
    data: productData,
    isLoading: isLoadingProductData,
    isError: isErrorProductData,
    error: productDataError,
  } = useQueryWithLoader({
    queryKey: ['product', id],
    queryFn: async () => {
      showLoader()
      const response = await baseServiceGetByColumn(
        entities.products.getById(id)
      )
      return response.result
    },
    select: (data) => {
      return {
        ...data,
        quantity: String(
          data.items.reduce((total, item) => total + item.quantity, 0)
        ),
        is_asset: data.is_asset ? 'Sim' : 'Não',
        items: data.items.map((item) => ({
          ...item,
        })),
      }
    },
  })

  useEffect(() => {
    if (!isLoadingProductData) {
      hideLoader()
    }
    if (isErrorProductData) {
      console.error('Erro ao carregar detalhes do produto:', productDataError)
      showNotification('error', 'Erro ao carregar os dados.')
      navigate('/almoxarifado/produtos')
    }
  }, [
    hideLoader,
    isErrorProductData,
    isLoadingProductData,
    navigate,
    productDataError,
    showNotification,
  ])

  useEffect(() => {
    if (!productData || Object.keys(productData).length === 0) return
    setFormData(productData)
  }, [productData, setFormData])

  const rows =
    productData?.items?.map((item) => ({
      code: item?.code || '-',
      address: item?.address?.formatted_address || '-',
      location: item?.location?.formatted_location || '-',
      category: item?.category?.name || '-',
      condition: item?.condition?.name || '-',
      price: item?.average_cost || 0,
      stock: item?.quantity || 0,
    })) || []

  const columns = [
    { key: 'code', label: 'Código' },
    { key: 'category', label: 'Categoria' },
    { key: 'condition', label: 'Condição' },
    { key: 'address', label: 'Endereço' },
    { key: 'location', label: 'Localização' },
    {
      key: 'price',
      label: 'Preço Médio',
      numeric: true,
      isMoney: true,
      align: 'right',
    },
    { key: 'stock', label: 'Estoque', numeric: true, align: 'right' },
  ]

  return (
    <MainLayout selectedCompany="ALUCOM">
      <PageHeader
        title="Detalhes do Produto"
        showBackButton={true}
        backUrl="/almoxarifado/produtos/"
      />

      <div className="container-fluid p-1">
        <DetailsSectionRenderer
          formData={formData}
          sections={detailsProductFields}
          readOnly
        />
        <div className="mt-4 shadow-sm rounded">
          <TableDetails data={rows} columns={columns} />
        </div>
      </div>
    </MainLayout>
  )
}

export default DetailsProductPage
